var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7142 16.7147L12.9856 12.9861M14.9999 8.14328C14.9999 11.9304 11.9299 15.0004 8.14279 15.0004C4.35569 15.0004 1.28564 11.9304 1.28564 8.14328C1.28564 4.35618 4.35569 1.28613 8.14279 1.28613C11.9299 1.28613 14.9999 4.35618 14.9999 8.14328Z",
    stroke: "#404F69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNew);
export default __webpack_public_path__ + "static/media/search_new.dab81361a5c6ad4b220980c6cfb77589.svg";
export { ForwardRef as ReactComponent };